import { defineMessages, useIntl } from 'react-intl';

const messages = defineMessages({
  heading: {
    id: 'More info bar heading',
    defaultMessage:
      'Per sol·licitar més informació sobre els nostres serveis o concertar una hora de visita:',
  },
  weekdays: {
    id: 'More info bar weekdays',
    defaultMessage: 'dilluns a divendres',
  },
  hours: {
    id: 'More info bar hours',
    defaultMessage: 'de 8 a 20 h',
  },
  patientApp: {
    id: 'More info bar patient app',
    defaultMessage: 'App Espai Pacient',
  },
});

const MoreInfoBar = () => {
  const intl = useIntl();

  return (
    <div className="more-info-bar">
      <span className="more-info-heading">
        {intl.formatMessage(messages.heading)}
      </span>
      <div className="more-info-list">
        <a className="more-info-item item-with-link" href="tel:938744298">
          <img src="/svg-icons/phone.svg" alt="" />
          <span className="more-info-item-text">93 874 42 98</span>
        </a>
        <div className="vertical-separator" />
        <div className="more-info-item">
          <img src="/svg-icons/calendar.svg" alt="" />
          <span className="more-info-item-text">
            {intl.formatMessage(messages.weekdays)}
          </span>
        </div>
        <div className="vertical-separator" />
        <a
          className="more-info-item item-with-link"
          href="mailto:visites@clinicasantjosep.cat"
        >
          <img src="/svg-icons/email.svg" alt="" />
          <span className="more-info-item-text">
            visites@clinicasantjosep.cat
          </span>
        </a>
        <div className="vertical-separator" />
        <div className="more-info-item">
          <img src="/svg-icons/clock.svg" alt="" />
          <span className="more-info-item-text">
            {intl.formatMessage(messages.hours)}
          </span>
        </div>
        <div className="vertical-separator" />
        <a
          className="more-info-item item-with-link"
          target="_blank"
          rel="noopener noreferrer"
          href="https://espaipacient.clinicasantjosep.cat/espai-client/cm/?locale=ca_ES"
        >
          <img src="/svg-icons/smartphone.svg" alt="" />
          <span className="more-info-item-text">
            {intl.formatMessage(messages.patientApp)}
          </span>
        </a>
      </div>
    </div>
  );
};

export default MoreInfoBar;
